import React from 'react';
import '../css/certifications.css';
import certificateImage from '../assets/certificate.PNG';
import bronzeCertificate from '../assets/certifications/bronze_certificate.PNG';
import tanCertificate from '../assets/certifications/tan_certificate.PNG';
import udyamCertificate from '../assets/certifications/udyam.PNG';

const Certifications = () => {
  const certifications = [
    {
      title: 'ISO 9001:2015 Certified',
      certificateNo: 'IN18193A',
      validTill: '07 April 2025',
      description: 'Reflects commitment to quality management, continual improvement, and customer satisfaction.',
      icon: (
        <svg width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/>
          <polyline points="14,2 14,8 20,8"/>
          <line x1="16" y1="13" x2="8" y2="13"/>
          <line x1="16" y1="17" x2="8" y2="17"/>
          <polyline points="10,9 9,9 8,9"/>
        </svg>
      )
    }
  ];

  const standards = [
    {
      category: 'Design & Dimensions',
      codes: ['ASME B16.10', 'ASME B16.34', 'ASME B16.5'],
      appliesTo: 'Valve design, face-to-face and flange dimensions',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" fill="#dc2626"/>
          <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2.5" fill="none"/>
        </svg>
      )
    },
    {
      category: 'Product Standards',
      codes: ['API 600', 'API 602', 'API 623', 'API 6D', 'API 594', 'API 608', 'API 609'],
      appliesTo: 'Industrial valves — Gate, Globe, Check, Ball, Butterfly',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" fill="#dc2626"/>
          <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2.5" fill="none"/>
        </svg>
      )
    },
    {
      category: 'Inspection & Testing',
      codes: ['API 598', 'ISO 12266', 'ISO 5208'],
      appliesTo: 'Valve performance and leak testing',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" fill="#dc2626"/>
          <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2.5" fill="none"/>
        </svg>
      )
    },
    {
      category: 'Material & Welding',
      codes: ['ASME/ANSI 16.34'],
      appliesTo: 'Material selection & pressure-temperature rating',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" fill="#dc2626"/>
          <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2.5" fill="none"/>
        </svg>
      )
    },
    {
      category: 'Special Requirements',
      codes: ['NACE MR-01-75'],
      appliesTo: 'Corrosion resistance for sour service',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" fill="#dc2626"/>
          <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2.5" fill="none"/>
        </svg>
      )
    },
    {
      category: 'Certification Standard',
      codes: ['ISO 9001:2015'],
      appliesTo: 'Quality Management System',
      icon: (
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" fill="#dc2626"/>
          <path d="M9 12l2 2 4-4" stroke="white" strokeWidth="2.5" fill="none"/>
        </svg>
      )
    }
  ];

  const highlights = [
    'Adheres to API / ASME / ISO / BS standards',
    'Material selection and testing are performed as per temperature, corrosion resistance, and client specifications',
    'Testing and inspection carried out according to international norms (API/BS)',
    'Fully aligned with the "Make in India" initiative, emphasizing precision engineering and quality manufacturing'
  ];

  return (
    <section className="certifications">
      <div className="container">
        <div className="certifications-header">
          <span className="certifications-label">Quality Assurance</span>
          <h2 className="certifications-title">Certifications & Standards</h2>
          <p className="certifications-subtitle">
            Our commitment to excellence is backed by rigorous certifications and adherence to global manufacturing standards.
          </p>
        </div>

        {/* Main Certification */}
        <div className="main-certification">
          <div className="certification-content">
            <div className="certificate-image-wrapper">
              <img 
                src={certificateImage} 
                alt="ISO 9001:2015 Certificate" 
                className="certificate-image"
              />
            </div>
          </div>
        </div>

        {/* Additional Certifications */}
        <div className="additional-certifications">
          <div className="certifications-grid">
            <div className="cert-item">
              <div className="cert-image-container">
                <img 
                  src={bronzeCertificate} 
                  alt="Bronze Certificate" 
                  className="cert-grid-image"
                />
              </div>
            </div>
            <div className="cert-item">
              <div className="cert-image-container">
                <img 
                  src={tanCertificate} 
                  alt="TAN Certificate" 
                  className="cert-grid-image"
                />
              </div>
            </div>
            <div className="cert-item">
              <div className="cert-image-container">
                <img 
                  src={udyamCertificate} 
                  alt="Udyam Certificate" 
                  className="cert-grid-image"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Standards Timeline */}
        <div className="standards-section">
          <h3 className="standards-title">Manufacturing & Quality Standards</h3>
          <p className="standards-subtitle">
            Comprehensive adherence to international standards ensuring quality, safety, and reliability in every product.
          </p>
          
          <div className="standards-container">
            <div className="standards-timeline">
              {standards.map((standard, index) => (
                <div 
                  key={index} 
                  className="standard-item"
                  style={{ animationDelay: `${index * 0.2}s` }}
                >
                  <div className="standard-content">
                    <div className="standard-header">
                      <div className="standard-icon">
                        {standard.icon}
                      </div>
                      <h4 className="standard-category">{standard.category}</h4>
                    </div>
                    <div className="standard-codes">
                      {standard.codes.map((code, codeIndex) => (
                        <span key={codeIndex} className="code-badge">{code}</span>
                      ))}
                    </div>
                    <p className="standard-applies">{standard.appliesTo}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Compliance Highlights */}
        <div className="compliance-section">
          <h3 className="compliance-title">Compliance Highlights</h3>
          <div className="compliance-list">
            {highlights.map((highlight, index) => (
              <div 
                key={index} 
                className="compliance-item"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="compliance-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22 11.08V12a10 10 0 11-5.93-9.14"/>
                    <path d="M22 4L12 14.01l-3-3"/>
                  </svg>
                </div>
                <p className="compliance-text">{highlight}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Certifications;
